import {ClubBookingApiClient} from "../../common/api/ClubBookingApiClient";
import {apiConfig} from "../../config/api";
import {PublicClientConfig} from "../../model/clients/PublicClientConfig";
import {PublicClientSummary} from "../../model/clients/PublicClientSummary";

export class ClientService extends ClubBookingApiClient {
    async getAvailableClients(): Promise<string[]> {
        return this.get<string[]>(
            `/clients`,
            undefined,
            { skipClientHeader: true }
        );
    }

    // Pre-login slug → client lookup. Called from ClientProvider before Auth0
    // is initialised, so it bypasses the base-class machinery (no token, no
    // X-Client-Id, no loading/notification side-effects). Returns null for
    // 400/404 so the caller can gracefully fall back to the apex flow.
    static async getPublicConfigBySubdomain(slug: string): Promise<PublicClientConfig | null> {
        const url = `${apiConfig.apiUrl}/clients/by-subdomain/${encodeURIComponent(slug)}`;
        const response = await fetch(url, {
            headers: { 'Accept': 'application/json' },
        });
        if (response.status === 400 || response.status === 404) return null;
        if (!response.ok) {
            throw new Error(`Public client config lookup failed for slug '${slug}': ${response.status}`);
        }
        return response.json();
    }

    // Public, unauthenticated club directory for the apex /clubs selector.
    // Same rationale as getPublicConfigBySubdomain: runs before any tenant is
    // chosen, so it bypasses the base-class machinery (no token, no
    // X-Client-Id, no loading/notification side-effects). The endpoint is
    // [AllowAnonymous] and edge-cached for 5 minutes.
    static async listPublicClients(): Promise<PublicClientSummary[]> {
        const url = `${apiConfig.apiUrl}/clients/public`;
        const response = await fetch(url, {
            headers: { 'Accept': 'application/json' },
        });
        if (!response.ok) {
            throw new Error(`Public clubs listing failed: ${response.status}`);
        }
        return response.json();
    }
}
